import cn from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { Core } from 'connex-cds';
import { BuildQrCode } from './BuildQrCode';
import { useQrSummary } from './QrSummaryProvider';

const Styled = styled.div`
  display: flex;
  justify-content: center;
`;

const QRCode = () => {
  const { summaryRef, loading, isReadyToSync, syncQrSummary } = useQrSummary();

  // Opening this tab picks up ticket edits while online. Load-time summary is already written
  // once GET + PDF + CoC are ready, so an offline open keeps that QR instead of waiting on the network.
  const hasSynced = React.useRef(false);

  React.useEffect(() => {
    if (hasSynced.current || !isReadyToSync) {
      return;
    }

    if (typeof navigator !== 'undefined' && navigator?.onLine === false) {
      return;
    }

    hasSynced.current = true;
    syncQrSummary?.();
  }, [isReadyToSync, syncQrSummary]);

  return (
    <Styled className={cn('qr-tab')}>
      <Core.Spinner spin={loading}>
        <BuildQrCode summaryRef={summaryRef} />
      </Core.Spinner>
    </Styled>
  );
};

export default QRCode;
